import { render, staticRenderFns } from "./newOrderTable.vue?vue&type=template&id=53cc8cff&"
import script from "./newOrderTable.vue?vue&type=script&lang=js&"
export * from "./newOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./newOrderTable.vue?vue&type=style&index=0&id=53cc8cff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports